import { OrderInProgressIcon } from "../../../../../assets/icons/OrderInProgressIcon";
import { CompletedOrdersIcon } from "../../../../../assets/icons/CompletedOrdersIcon";
import { CancelledOrdersIcon } from "../../../../../assets/icons/CancelledOrdersIcon";

import AText from "core/presentation/components/Text";
import ATitle from "core/presentation/components/Title";
import { useNavigate } from "react-router-dom";
import { typography } from "theme/Typography";
import { Col, Row } from "antd";
import { useAppSelector } from "core/presentation/store/hooks";

const OrderSummary = () => {
  const navigate = useNavigate();

  const { dashboardData } = useAppSelector((state) => state.user);

  const summaryData = [
    {
      icon: <CompletedOrdersIcon />,
      title: "Completed Orders",
      count: dashboardData?.orders?.convertedOrderData?.CompletedOrders ?? 0,
    },
    {
      icon: <OrderInProgressIcon />,
      title: "Orders in Progress",
      count: dashboardData?.orders?.convertedOrderData?.OrderInProgress ?? 0,
    },
    {
      icon: <CancelledOrdersIcon />,
      title: "Cancelled Orders",
      count: dashboardData?.orders?.convertedOrderData?.CancelledOrders ?? 0,
    },
  ];

  return (
    <>
      <ATitle
        content={"Summary"}
        style={{ fontSize: typography.fontSizes.twoxl }}
      />
      <Row
        gutter={[16, 16]}
        style={{ marginTop: "16px", marginBottom: "20px" }}
      >
        {summaryData.map((item, index) => (
          <Col key={index} xs={24} sm={24} md={8}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
                border: "1px solid #EAECF0",
                borderRadius: "8px",
                background: "#fff",
              }}
            >
              <div
                style={{
                  marginRight: "16px",
                  backgroundColor: "#F6F6F6",
                  padding: "15px",
                  borderRadius: "50%",
                }}
              >
                {item.icon}
              </div>
              <div>
                <ATitle
                  content={item.title}
                  fontSize={14}
                  fontWeight={600}
                  marginTop="0"
                  lineHeight={2}
                />
                <AText fontSize={28} fontWeight={700}>
                  {item.count}
                </AText>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default OrderSummary;
